import styled from 'styled-components';
import { theme } from 'assets/styles/theme';
import { DeviceUp } from 'assets/styles/breakpoints';

const OrgSelectorStyled = styled.div`
  padding: 0 20px 22px 34px;
  margin-bottom: 10px;
  border-bottom: solid 1px ${theme.secondary};

  @media ${DeviceUp.xl} {
    padding: 0 24px 26px 40px;
  }

  label {
    display: block;
  }

  .field-label {
    display: block;
    margin: 0 0 8px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #70787e;
  }

  select {
    width: 100%;
    padding: 9px 12px;
    border: solid 1px #d5dbe0;
    border-radius: 6px;
    background: #fff;
    font-size: 13px;
    color: ${theme.text};
    cursor: pointer;
    transition: border-color linear 0.2s;

    &:hover,
    &:focus {
      border-color: ${theme.primary};
      outline: none;
    }
  }

  .org-retry {
    display: block;
    margin-top: 8px;
    padding: 0;
    border: none;
    background: none;
    font-size: 12px;
    font-weight: 600;
    color: #d0021b; /* theme has no danger token; matches notification 'danger' red */
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export default OrgSelectorStyled;
